module.exports = __webpack_public_path__ + "img/bg2.56385efa.png";